import { render, staticRenderFns } from "./HomeFaq.vue?vue&type=template&id=7923539a"
import script from "./HomeFaq.vue?vue&type=script&lang=js"
export * from "./HomeFaq.vue?vue&type=script&lang=js"
import style0 from "./HomeFaq.vue?vue&type=style&index=0&id=7923539a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports